var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColorReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77736 16.6539C1.68092 13.9751 1.68086 11.0246 2.77736 8.34583C3.69858 6.09523 5.30121 4.26315 7.35982 3.07681V7.55477H9.1297V0.749023H2.40439V2.54009H4.98576C0.67905 5.9529 -1.05095 11.9813 1.14217 17.3394C1.97797 19.3813 3.32915 21.1698 5.04971 22.5116C6.71776 23.8124 8.69997 24.6729 10.7819 24.9998L11.0533 23.2299C7.31634 22.6431 4.22259 20.1848 2.77736 16.6539Z",
    fill: "url(#paint0_linear_472_1835)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2329 17.3394C25.5102 14.2186 25.5102 10.7812 24.2329 7.66045C23.3971 5.61851 22.0459 3.83002 20.3254 2.48827C18.6573 1.18736 16.6751 0.326929 14.5932 0L14.3218 1.76993C18.0587 2.35674 21.1525 4.81504 22.5977 8.34589C23.6941 11.0247 23.6941 13.9752 22.5977 16.654C21.6765 18.9046 20.0738 20.7367 18.0153 21.923V17.445H16.2454V24.2508H22.9706V22.4597H20.3969C22.0756 21.1333 23.3958 19.3846 24.2329 17.3394Z",
    fill: "url(#paint1_linear_472_1835)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_472_1835",
    x1: 5.62212,
    y1: 0.749023,
    x2: 5.62212,
    y2: 24.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71B54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BACE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_472_1835",
    x1: 19.7563,
    y1: 0,
    x2: 19.7563,
    y2: 24.2508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71B54D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BACE"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorReload);
export default __webpack_public_path__ + "static/media/color-reload.b03e58097e99a40f9a34ce4001c84489.svg";
export { ForwardRef as ReactComponent };